// extracted by mini-css-extract-plugin
module.exports = {"infoBlock":"info-box_infoBlock__1VGXl","grey":"info-box_grey__X8fHb","infoBlockIcon":"info-box_infoBlockIcon___UKO0","infoBlockText":"info-box_infoBlockText__1m7dF"};